export default "//yastatic.net/s3/distribution/pythia/frontend/_/5e3d20aa63c098924d568a9ebb1907d7.png";